module.exports = __webpack_public_path__ + "images/high-roller-4c383edd54b59f44ccffee4fe7ad8f60.png";